// extracted by mini-css-extract-plugin
module.exports = {"Container":"NewsBanner_Container__10M84","TextContainer":"NewsBanner_TextContainer__2APm5","NotificationContent":"NewsBanner_NotificationContent__3ogqq"};